import React from "react";
import { Block, Row, Col, Button, Icon } from "framework7-react";
import { setLiteral, obtenerTextoAntesDeHTML } from "../../../js/helpers";

const ContactSection = ({ configMiApp, lsLiterales }) => {
  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => alert(`Texto copiado: ${text}`))
      .catch((err) => console.error("Error al copiar:", err));
  };

  return (
    <div>
      <Col width="100">
        <Row style={{ marginTop: 10 }}>
          <Col
            className="contenedorPrincipal padding faqsCont"
            width="90"
            small={90}
            medium={45}
            xsmall={90}
          >
            <Row>
              <Col className="center">
                <Block>
                  <Icon f7="phone"></Icon>
                </Block>
              </Col>
            </Row>
            <Row>
              <Col
                width="100"
                className="center large bold alignercerter"
                style={{ marginTop: 5 }}
              >
                {configMiApp.contact_phone}
              </Col>
            </Row>
            <Row>
              <Col
                width="100"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  id="clip"
                  className="alignercerter"
                  iconF7="doc_on_clipboard"
                  onClick={() => handleCopy(configMiApp.contact_phone)}
                ></Button>
              </Col>
            </Row>
            <Block />
          </Col>
          <Col
            className="contenedorPrincipal padding faqsCont"
            width="90"
            small={90}
            medium={45}
            xsmall={90}
          >
            <Row>
              <Col className="center">
                <Block>
                  <Icon f7="text_bubble_fill"></Icon>
                </Block>
              </Col>
            </Row>
            <Row>
              <Col width="100" className="generalTitl">
                {obtenerTextoAntesDeHTML(setLiteral(lsLiterales, 101022))}
              </Col>
            </Row>
            <Row>
              <Col width="100" className="center samll bold alignercenter">
                {configMiApp.miapp_contact_email}
              </Col>
            </Row>
            <Row>
              <Col
                width="100"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  id="clip"
                  iconF7="doc_on_clipboard"
                  onClick={() => handleCopy(configMiApp.miapp_contact_email)}
                ></Button>
              </Col>
            </Row>
            <Block />
            {/* <Row>
                            <Col width="10"></Col>
                            <Col width="20" className='center'><Button className='clip' iconF7='logo_facebook'></Button></Col>
                            <Col width="20" className='center'><Button className='clip' iconF7='logo_twitter'></Button></Col>
                            <Col width="20" className='center'><Button className='clip' iconF7='logo_linkedin'></Button></Col>
                            <Col width="10"></Col>
                        </Row> */}
            <Block />
          </Col>
          {/* </div> */}
        </Row>
        <br />
        <Row>
          <Col width="100" className="large center">
            {setLiteral(lsLiterales, 101116)}
          </Col>
        </Row>
        <br />
        <Row className="aligner">
          <Col width="50" medium={50} small={90} xsmall={90}>
            <Row>
              <Col width="100" className="bold center">
                {setLiteral(lsLiterales, 101117)}
              </Col>
            </Row>
            <Row>
              <Col width="100" className="light center">
                {setLiteral(lsLiterales, 101118)}
              </Col>
            </Row>
          </Col>
          <Col width="50" medium={50} small={90} xsmall={90}>
            <Row>
              <Col width="100" className="bold center">
                {setLiteral(lsLiterales, 101119)}
              </Col>
            </Row>
            <Row>
              <Col width="100" className="light center">
                {setLiteral(lsLiterales, 101120)}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default ContactSection;
